<header mat-dialog-title>
  <div class="header-title-content">
    <span *ngIf="tenant">Modifica punto vendita: {{ tenant.name }}</span>
    <span *ngIf="!tenant" class="new-item">Nuovo punto vendita</span>
  </div>

  <div class="header-actions" *ngIf="tenant">
    <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
      <button mat-menu-item (click)="deleteTenant()">
        <mat-icon>delete</mat-icon>
        Disattiva punto vendita
      </button>
    </mat-menu>
  </div>
</header>

<mat-dialog-content>
  <form [formGroup]="tenantsForm" novalidate>
    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="name" placeholder="Nome punto vendita" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Telefono</mat-label>
        <input matInput formControlName="phone" placeholder="Telefono" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Città</mat-label>
        <input matInput formControlName="city" placeholder="Città" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>
    </div>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Indirizzo</mat-label>
        <input matInput formControlName="address" placeholder="Via delle Industrie, 44" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>
    </div>


    <div class="u-flex-full">

      <mat-form-field class="u-full-width">
        <mat-label>Numero massimo di prodotti ordinabili</mat-label>
        <input matInput formControlName="maxOrderableProductsPerInterval" type="number" placeholder="Es. 10" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Punti target Fidelity Card</mat-label>
        <input matInput formControlName="fidelityCardTargetPoints" type="number" placeholder="Es. 100" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>
    </div>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Intervallo temporale (minuti)</mat-label>
        <input matInput formControlName="timeSlotInterval" type="number" placeholder="Es. 30" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>

      <!-- Tempo minimo per ordine -->
      <mat-form-field class="u-full-width">
        <mat-label>Tempo minimo per ordine (minuti)</mat-label>
        <input matInput formControlName="minimumOrderIntervalTime" type="number" placeholder="Es. 15" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>
    </div>


    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Chiave pubblica Stripe</mat-label>
        <input matInput formControlName="stripePublicKey" placeholder="Chiave pubblica" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Chiave privata Stripe</mat-label>
        <input matInput formControlName="stripePrivateKey" placeholder="Chiave privata" />
        <mat-error>Campo obbligatorio</mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="left-actions">
    <button mat-stroked-button type="button" (click)="revert()" [disabled]="tenantsForm.pristine">
      Reset
    </button>
    <button mat-raised-button color="primary" type="button" (click)="save()"
      [disabled]="tenantsForm.pristine || !tenantsForm.valid">
      Salva
    </button>
  </div>
  <div class="right-actions">
    <button mat-button type="button" (click)="close()">
      Chiudi
    </button>
  </div>
</mat-dialog-actions>
